import { useTranslation } from "@outschool/localization";
import { useQueryWithPreviousData } from "@outschool/ui-apollo";
import { ListingsByActivityUidsQuery } from "@outschool/ui-components-website";
import _ from "lodash";
import React from "react";

import ListingCarousel from "./ListingCarousel";

export type ClassLinkType = {
  uid: string;
  title: string;
  isOrdered: boolean;
  bundleElements: BundleElementType[];
};

export type BundleElementType = {
  orderInBundle: number;
  activity: {
    uid: string;
  };
};

export function ClassLinkCarousel({
  classLink,
  currentActivityUid,
  carouselRowNum,
}: {
  classLink: ClassLinkType | null;
  currentActivityUid: string;
  carouselRowNum: number;
}) {
  const { t } = useTranslation("client\\components\\listings\\carousels");
  const activityUids = _.sortBy(
    classLink?.bundleElements ?? [],
    el => el.orderInBundle,
  ).map((el: BundleElementType) => el.activity.uid);
  const { data } = useQueryWithPreviousData(ListingsByActivityUidsQuery, {
    variables: {
      activityUids: activityUids,
      skipRating: false,
      withRecentReviews: false,
    },
  });

  if (!classLink || activityUids.length == 0) {
    return null;
  }

  return (
    <ListingCarousel
      // sx={{ padding: 0 }}
      listings={data?.listingsByActivityUids}
      title={t("Explore: {{title}}", { title: classLink.title })}
      trackingLabel="class links"
      carouselRowNum={carouselRowNum}
      currentIndex={activityUids.indexOf(currentActivityUid)}
      leftAlign
      headingSx={{ textAlign: "left" }}
    />
  );
}
